import type React from 'react'
import type { Dispatch, SetStateAction } from 'react'

import { Alert, Modal } from 'components'

import * as S from './styles'

interface ModalConfirmGenerationProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  onConfirm: () => void
  onReturn?: () => void
}

const ModalConfirmGeneration: React.FC<ModalConfirmGenerationProps> = ({
  open,
  setOpen,
  onConfirm,
  onReturn = () => setOpen(false),
}) => {
  return (
    <Modal
      buttonAction={onConfirm}
      buttonText="Criar novo pedido"
      closeAction={onConfirm}
      modalWidth={456}
      open={open}
      returnAction={onReturn}
      returnIcon={''}
      returnText="Gerenciamento"
      setOpen={setOpen}
      showClose={false}
      showReturn
      titleSize={22}
    >
      <S.DescriptionContainer>
        <Alert
          fullWidth
          kind="success"
          message="Assim que o sistema concluir a geração, uma notificação será enviada para o seu email."
          title={'Geração de OVs iniciada!'}
        />
        <S.ObservationText>
          Enquanto aguarda por um retorno do Portal, você pode criar novos pedidos.
        </S.ObservationText>
        <S.ObservationText>
          As OVs geradas serão <b>enviadas automaticamente ao SAP.</b> Materiais em aberto ou em
          análise <b>não possuem garantia de disponibilidade.</b>
        </S.ObservationText>
      </S.DescriptionContainer>
    </Modal>
  )
}

export default ModalConfirmGeneration
